import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './Tooltip.scss';
import classNames from 'classnames';

const Tooltip = ({ children, content, direction, disableMouseHover, hideTooltip }) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    setActive(true);
  };

  const hideTip = () => {
    setActive(false);
    clearInterval(timeout);
  };

  return (
    <div
      className={classNames('tmx-TooltipWrapper', {
        'tmx-TooltipWrapper--disable': disableMouseHover
      })}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}>
      {children}
      <div
        className={classNames(`tmx-TooltipWrapper__Tooltip-Tip ${direction || 'top'}`, {
          hide: hideTooltip
        })}
        style={{
          visibility: active ? 'visible' : 'hidden',
          transition: 'visibility',
          transitionDelay: active ? '1s' : '0s'
        }}>
        {content}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disableMouseHover: PropTypes.bool,
  hideTooltip: PropTypes.bool
};

export default Tooltip;
